import React from 'react';
import PropTypes from 'prop-types'

import { ImageCarousel } from '../'
import { browserUtils } from '../../utils'
import emailIcon from '../../assets/icons/email.svg'
import './ToolDetailHeader.sass'


const isMobileOrTablet = browserUtils.isMobileOrTabletDevice()

function generateMailLink(name) {
  return `mailto:?subject=Gulf Tree: ${name}&body=Learn more about this tool at ${window.location.href}`
}

const ToolDetailHeader = ({ tool }) => {
  return (
    <section className="tool-detail-header">
      <div className="content">
        <h1>{tool.name}</h1>
        <p className="tool-author">by {tool.developer}</p>
        <div className="tool-description" dangerouslySetInnerHTML={{__html: tool.abstract}} />
        <div className="header-btns">
          <a
            className="btn-transparent header-btn"
            href={tool.url}
            rel="noopener noreferrer"
            target="_blank"
          >
            get tool
          </a>
          { !isMobileOrTablet &&
            <button type="button" className="btn-transparent header-btn" onClick={window.print}>Printer-Friendly Version</button>
          }
          { isMobileOrTablet &&
            <a
              className="header-btn"
              href={generateMailLink(tool.name)}
              rel="noopener noreferrer"
              target="_top"
            >
              <img src={emailIcon} alt="email" className="header-btn" />
            </a>
          }
        </div>
      </div>
      { tool.photos.length ?
        <div className="images">
          <ImageCarousel images={tool.photos.map(photo => photo.url)} />
        </div> : null
      }
    </section>
  )
}

ToolDetailHeader.propTypes = {
  tool: PropTypes.object
}

export default ToolDetailHeader
